import { v7 } from "uuid";

export const uid = v7;
export default uid;